export const saveLeadEnrichmentToLocalStorage = ({localStorage, leadEnrichmentValue, key}) => {
  const existingData = localStorage.getItem(key)
  if (existingData) {
    const parsedData = JSON.parse(existingData)
    const mergeLeadEnrichmentValue = {...parsedData, leadEnrichmentValue}
    localStorage.setItem(key, JSON.stringify(mergeLeadEnrichmentValue))
    return
  }
  const currentDataKeyValue = {leadEnrichmentValue}
  localStorage.setItem(key, JSON.stringify(currentDataKeyValue))
}

export const getLeadEnrichmentFromLocalStorage = ({localStorage, key}) => {
  const existingData = localStorage.getItem(key)
  if (existingData) {
    const {leadEnrichmentValue} = JSON.parse(existingData)
    return leadEnrichmentValue
  }
  return null
}

export const BLOCKED_USERS_COOKIE_KEY = 'blocked_users'
export const GENERIC_ERROR = 'GENERIC_ERROR'
